export enum AdminTaskTypeEnum {
  Call = 1,
  Email = 2,
  Brokerage
}
